import { CMS, SALES, SERVICE } from 'self-service-api/constants/ProductLines';
export const MAX_VISIBLE_PURCHASE_MOTIONS_PA = (productLine, useIsHC0124Variant) => {
  if (useIsHC0124Variant) {
    return 2;
  }
  if (productLine && [CMS, SALES, SERVICE].includes(productLine)) {
    return 3;
  }
  return 2;
};